import type { Static } from '@sinclair/typebox';
import { LotterySchema } from '@lotta/shared/types-lottery-schemas';

export type LotteryResponse = Static<typeof LotterySchema>;
export const LotteryResponseSchema = LotterySchema;
